import React from 'react';
import CONSTANTS from './constants.js'
import {connect} from 'react-redux'

const mapDispatchToProps =  (dispatch) => {
    return {
        resetClicked: () => dispatch(CONSTANTS.ACTION_CREATORS.resetEverything())
    };
} 

class Reset extends React.Component{
    constructor(props){
        super(props);
        
        this.resetClick = this.resetClick.bind(this);
    }
    
    resetClick(){
        this.props.resetClicked();
    }
    
    render(){
        return(
            <div className='reset outerWrapper'>
                <button id="reset" type='button' onClick={this.resetClick}>Reset</button>
            </div>
        )
    }
}

export default connect(CONSTANTS.MAP_STATE_TO_PROPS, mapDispatchToProps)(Reset);